export const TILE_INTRO_DATA = [
  {
    title: 'Opening Your Menu',
    image: 'assets/images/tile-tour/tour1.png',
    content:
      '<p>Use this menu to get immediate access to every available resource. No matter where you go within Atlas, you can always click Home to get back to your dashboard.</p>'
  },
  {
    title: 'Levels',
    image: 'assets/images/tile-tour/tour2.png',
    content:
      '<p>Your course lessons are separated into different levels. We recommend you attempt each lesson at least once before moving on to higher levels.</p>'
  },
  {
    title: 'Lessons & Progress',
    image: 'assets/images/tile-tour/tour3.png',
    content:
      '<p>Each lesson displays a progress or completion indicator, letting you know at a glance which lessons need attention.</p>'
  },
  {
    title: 'End of Level Exam',
    image: 'assets/images/tile-tour/tour4.png',
    content: "<p>Levels end with a full-length practice exam that let you know how you're doing before moving on.</p>"
  },
  {
    title: 'Switch Syllabus',
    image: 'assets/images/tour7.png',
    content:
      '<p>The name of your current syllabus is displayed at the top of your screen. Use the arrow icon (&#x21c4;) to load any other syllabus you may have access to.</p>'
  }
]



// WEBPACK FOOTER //
// ./src/app/intro/tile-intro.data.ts